import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Transfer, Table, Row, Col, Select, Button} from 'antd'
import {toJS} from 'mobx'
import difference from 'lodash/difference'
import {withTranslation} from 'react-i18next'

@inject('roleManagementStore', 'permissionManagementStore')
@observer
class PermissionFormModal extends Component {
  state = {}
  formRef = React.createRef()

  componentDidMount() {
  }

  /*change permissionType*/
  onChangeType = (value) => {
    const {roleManagementStore, permissionManagementStore} = this.props
    const {searchItem} = permissionManagementStore
    permissionManagementStore.onChangePermissionType(value)
    permissionManagementStore.onSearchAction(searchItem, 1, '99999999')
    roleManagementStore.changeTargetKeys(value)
  }
  /*change targetKeys*/
  onChange = (targetKeys) => {
    const {roleManagementStore} = this.props
    roleManagementStore.getRoleUserListData(targetKeys)
  }
  /*bind permission*/
  handleOk = () => {
    const {roleManagementStore, permissionManagementStore, handleCancelPermission, record} = this.props
    const {targetKeys, oldArr} = roleManagementStore
    const {permissionType} = permissionManagementStore
    var diffArr = []
    var params = []
    for (var i = 0; i < oldArr.length; i++) {
      if (targetKeys.indexOf(oldArr[i]) === -1) {
        diffArr.push(oldArr[i])
      }
    }
    targetKeys.map(item => {
      return params.push({
        id: item,
        addOrDelete: true,
        resourceType: permissionType
      })
    })
    diffArr.map(item => {
      return params.push({
        id: item,
        addOrDelete: false,
        resourceType: permissionType
      })
    })
    roleManagementStore.onAddPermissionAction({'bindPermissionVOs': params}, record.id).then(res => {
      roleManagementStore.getRoleUserListData([])
    })
    permissionManagementStore.onChangePermissionType('MENU')
    handleCancelPermission()
  }

  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {roleManagementStore, permissionManagementStore, permissionModalVisible, handleCancelPermission, t} = this.props
    const {permissionList} = permissionManagementStore
    const {targetKeys} = roleManagementStore
    return (
      <>
        <Modal
          title={t(`roleManagement.permissionConfig`)}
          closable={true}
          onCancel={handleCancelPermission}
          visible={permissionModalVisible}
          // onOk={this.handleOk}
          // onCancel={handleCancelPermission}
          maskClosable={false}
          destroyOnClose={true}
          width="90%"
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancelPermission}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addPermission" initialValues={{type: 'MENU'}}>
            <Row wrap={true} gutter={[10, 10]}>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8} span={8}>
                <Form.Item name="type" label={t(`roleManagement.permissionType`)}>
                  <Select placeholder="Please enter type" allowClear onChange={this.onChangeType}>
                    {/*<Select.Option key='OPERATION' value='OPERATION'>OPERATION</Select.Option>*/}
                    {/*<Select.Option key='API' value='API'>API</Select.Option>*/}
                    <Select.Option key="MENU" value="MENU">MENU</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Transfer
              dataSource={permissionList}
              targetKeys={toJS(targetKeys)}
              showSearch
              titles={[t(`roleManagement.unselectedList`), t(`roleManagement.selectedList`)]}
              rowKey={record => record.id}
              onChange={this.onChange}
              filterOption={(inputValue, item) =>
                item.name.indexOf(inputValue) !== -1 || item.description.indexOf(inputValue) !== -1
              }
            >
              {({
                  direction,
                  filteredItems,
                  onItemSelectAll,
                  onItemSelect,
                  selectedKeys: listSelectedKeys,
                }) => {
                const rowSelection = {
                  onSelectAll(selected, selectedRows) {
                    const treeSelectedKeys = selectedRows
                      .filter(item => !item.disabled)
                      .map(({id}) => id)
                    const diffKeys = selected
                      ? difference(treeSelectedKeys, listSelectedKeys)
                      : difference(listSelectedKeys, treeSelectedKeys)
                    onItemSelectAll(diffKeys, selected)
                  },
                  onSelect({id}, selected) {
                    onItemSelect(id, selected)
                  },
                  selectedRowKeys: listSelectedKeys,
                }
                return (
                  <Table
                    rowSelection={rowSelection}
                    dataSource={filteredItems}
                    pagination={false}
                    scroll={{y: 300}}
                    rowClassName={this.getRowClassName}
                  >
                    <Table.Column title={t(`roleManagement.name`)} dataIndex="name" key="name"/>
                    <Table.Column title={t(`roleManagement.description`)} dataIndex="description" key="description"/>
                  </Table>
                )
              }}
            </Transfer>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(PermissionFormModal)
